
/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色权限</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->



    <!--列表-->
    <el-table id="educe-table"  ref="multipleTable" stripe :data="listData" highlight-current-row
      v-loading="loading" @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
      style="width: 100%; font-size: 18px; margin-top: 50px;">

      </el-table-column>
      <el-table-column align="center" prop="roleId" label="角色ID" width="100">
      </el-table-column>
      <el-table-column align="center" prop="roleName" label="角色名称" >
      </el-table-column>
      <el-table-column prop="closeTime"  align="center" fixed="right" label="操作" width="250" v-if="roleId.roleId==1">
        <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" @click="onClick(scope.row,1)">编辑</el-button>
            <!-- <el-button type="danger" icon="el-icon-delete" @click="onClick(scope.row,2)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
   
      <el-dialog title="角色信息"  width="30%"   :visible.sync="dialogFormVisible">
  <el-form :model="editForm"  :rules="rules" ref="editForm" >
    <el-form-item label="角色姓名" prop="name"  :label-width="formLabelWidth">
      <el-input v-model="editForm.name"    autocomplete="off"></el-input>
    </el-form-item>
    
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="addRole">确 定</el-button>
    
    el-tree
  </div>
</el-dialog>

<el-drawer
@close="onsetCheckedKey"
  title="菜单列表"
  :visible.sync="drawer"
  >
  <el-tree
 
  ref="tree"
  @node-click="handleNodeClick"
  :data="datas"
  show-checkbox
  node-key="id"
 
 
  default-expand-all

  :default-checked-keys="expandedlist"
  :props="defaultProps">
</el-tree>

<div style="margin-left: 30%; margin-bottom: 30px;">
    <el-button @click="onsetCheckedKeys">取 消</el-button>
  
    <el-button :type="checkAll?'success':'warning'" @click="addRoleAll">{{ checkAll?'清空':"全选" }}</el-button>
    <el-button type="primary" @click="addRole">确 定</el-button>
</div>
<!--  -->

   


</el-drawer>

  </div>
</template>

<script>
import Vue from 'vue'
import {roleList,roleAdd,roleDelete,roleEdit,getListByRole,getMenuList,menuEdit } from '../../api/userMG'
import Axios from 'axios'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      dialogVisible: false,
      value: "",
      options123: [],
      drawer: false,
      roleIdls:'',
      datas: [],
    
      expandedlist:[],
      checkAll: false,
        defaultProps: {
          children: 'children',
          label: 'name'
        },
      ssoServer:"",
      formLabelWidth: '120px',
      dialogFormVisible:false,
      options1234123: [],
      ifindex:"",
      aData: new Date(),

      adder: "",
      recommendform: {
        index: "",
        id: ""
      },
      roleId:"",
      checkAlls:true,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      SelectList:'',
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
    
      editForm: {
        name: '',
      },

      // rules表单验证
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        name:"",
        current: 1,
        size: 20,
      },
      ids:"",
      expandedlisx:"",
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    getMenuList().then(res=>{
      this.datas=res.data
    })
    this.roleId=JSON.parse(localStorage.getItem('userlist'))
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    this.value=(new Date()).getTime();
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId
  },
  mounted() {
    this.formLIst()
    Axios({
        method: 'get',
        url: this.ssoServer+'/api/platform-user/getSelectList',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        this.SelectList =res.data.data

      })



  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    onClick(row,index){

      let that = this
setTimeout(function() {
  row.menuIds.forEach(value => {
that.$refs.tree.setChecked(value, true, false);
});
}, 10);




      // this.expandedlist=row.menuIds
      // console.log(this.expandedlist);
          this.drawer=true
          
          this.roleIdls=row.roleId

    },
    addRoleAll(){
      
        if (this.checkAll == false) {
          this.checkAll = true;
          
          
          this.$refs.tree.setCheckedNodes(this.datas);
      } else {

        this.$refs.tree.setCheckedKeys([]);
        this.checkAll = false;
      }
    },
        onsetCheckedKeys(){
    
      this.$refs.tree.setCheckedKeys([]);
      this.formLIst()
      this.drawer=false
    },
    onsetCheckedKey(){
    
    this.$refs.tree.setCheckedKeys([]);
    this.formLIst()
    this.drawer=false
  },
  handleNodeClick(data, node, self) {
   
      // 如果当前节点是子节点并且它被选中了，则取消其父节点的选中状态
      if (node.parent && node.parent.isSelected(node.parent.data)) {
        this.$refs.tree.setChecked(node.parent.data, false);
        
      }
      // 其他的点击处理逻辑...
    },
    addRole(){
  let zi = this.$refs.tree.getCheckedKeys()//返回选中子节点的key
 let fu =this.$refs.tree.getHalfCheckedKeys()//返回选中子节点的父节点的key
 let new1 = zi.concat(fu)
 this.expandedlist=new1
    menuEdit({
      menuId:this.expandedlist,
      roleId:this.roleIdls
    }).then(res=>{
      if(res.code==0){
        this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.formLIst()
              
              this.$refs.tree.setCheckedKeys([]);
              this.drawer=false

      }
    })
    return
        if(this.ifindex==1){
            roleAdd({
            name:this.editForm.name
        }).then(res=>{
        if(res.code==0){
            this.$message({
                type: 'success',
                message: '添加成功'
              })
              this.formLIst()
            this.dialogFormVisible=false
         
        }
        })
        }else{
            roleEdit({
            name:this.editForm.name,
            id:this.ids
        }).then(res=>{
        if(res.code==0){
            this.$message({
                type: 'success',
                message: '编辑成功'
              })
              this.formLIst()
            this.dialogFormVisible=false
         
        }
        })  
        }
       

    },
    

   
    
    recommend(i, f) {
      if (i == -1) {
        this.recommendform.id = f.id
        this.recommendform.index = 0

        this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '取消成功'
              })
              this.formLIst()
            }
          })

        }).catch(() => {

        });
        return

      }else{
        this.editFormVisible = true

      }
      this.recommendform.id = f.id

     
      this.recommendform.index = ''

    },




    addCogilg() {
        this.ifindex='1'
        this.editForm.name=''
        this.dialogFormVisible=true
    },
    selectall(val) {
      // console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      // console.log(val);
    },



    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    selectalls(rows) {

      if (rows) {
        let data = []
        rows.forEach((item) => {
          data.push(item.id)
          this.importList = data
          console.log(this.importList);

        })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        console.log('1212112');
        this.importList = []

        this.$refs.multipleTable.clearSelection();//清除全选
      }


    },

    onChange(e,l) {
      console.log(e,l);

      // this.formInline.activityAddressCode = e[1]
      // console.log( this.formInline.registerAddress);


    },
    selectall(val) {

      let data = []
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer+'/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList,
            searchType: 1
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      //  this.formInline =''
      this.$refs[formInline].resetFields();
    },
    formLIst() {
      getListByRole(this.formInline).then(res=>{
            if(res.code==0){
            this.listData = res.data
        this.pageparm.total = res.data.total
            }
        })
    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;
    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current = 1
      this.value=(new Date()).getTime();

      this.formLIst()
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.$router.push({
    path:"/Eventmanagement/Eventdetails",
    query:{ //query是个配置项
        id:row.id
    }
})
      
      // this.editFormVisible = true
      // if (row != undefined && row != 'undefined') {
      //   this.title = '修改'
      //   this.editForm.deptId = row.deptId
      //   this.editForm.deptName = row.deptName
      //   this.editForm.deptNo = row.deptNo
      // } else {
      //   this.title = '添加'
      //   this.editForm.deptId = ''
      //   this.editForm.deptName = ''
      //   this.editForm.deptNo = ''
      // }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.recommendform.index==''){
            return this.$message({
                type: 'warning',
                message: '推荐排序不能为空'
              })
          }
          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '推荐成功'
              })
              this.editFormVisible = false
              this.formLIst()

            }else{
              this.$message({
                type: 'warning',
                message: res.data.message
              })
              return

            }

        
          })
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/adminiStration/Menupermissions.vue